import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import '../styles/navbar.css';

const Navbar = ({ setShowSpinner, 
    setSpinnerMessage, 
    setIsRegistrationModalOpen,
    hasSession,
    setHasSession,
    syncFiles,
    email
}) => {
  const { isDarkMode } = useContext(ThemeContext);

  const handleSyncFiles = () => {
    startGoogleAuthFlow();
    console.log("check credentials")
    if (!hasSession) {
        console.log("no session opening registration modal")
        setIsRegistrationModalOpen(true);
    }
    // console.log("Sync Files button clicked - redirecting to auth");
    // setSpinnerMessage('Preparing to sync your files...');
    // setShowSpinner(true);

    // setTimeout(() => {
    //     console.log("Redirecting to auth after spinner");
    //     window.location.href = `http://localhost:8000/authorize`;
    //   }, 3000);

  };

  return (
    <nav className={`navbar ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="logoName">
        <img 
          src="smallAlphaLogo.png" 
          alt="Svount Logo" 
          className="logoImage" 
        /><p>Svount</p>
      </div>
      <div className="nav-buttons">
        <button 
          className="feedback-button"
          onClick={() => window.open('https://feedback50meta.featurebase.app', '_blank')}
        >
          Feedback
        </button>
        <button
          className="sync-button"
          onClick={syncFiles}
        >
          Sync Files
        </button>
        <button 
          className="profile-button"
          onClick={() => document.getElementById('profile-drawer').classList.add('open')}
        >
          <p>{email ? email : "Profile"}</p>
        </button>
      </div>
    </nav>
  );
};

export default Navbar; 